
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import Upload from '@/components/Upload'
export default {
name: 'Order',
components: {
Cell,
Group,
Timeline,
TimelineItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
XTextarea
},
data() {
return {
ID: '',
isComplete: false,
uploadParams: {},
color: 'red',
order: {},
position: {},
orderFiles: [],
demageFiles: [],
hasOrderImg: false, // 是否已经提交提货交接单
hasDemageImg: false 
}
},
created() {
this.ID = this.$route.query.ID || ''
this.loadData()
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.color = _this.order.STATUS == 2 ? '#04BE02' : 'red'
_this.isComplete = _this.order.STATUS == 2 ? true : false
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getOrderFiles() {
let _this = this;
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
if (res.length > 0) _this.hasOrderImg = true
_this.orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
if (res.length > 0) _this.hasDemageImg = true
_this.demageFiles = res
});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/bmw/th/Order.vue